import { useContext } from "react";

import { GlobalStateContext } from "@lib/globalState";

export const useGlobalState = () => {
  return useContext(GlobalStateContext);
};
